"use strict";
var employeesList = document.querySelector("ul");
function parseSalary(item) {
    return Number(item.dataset.salary.replace(/[^0-9.-]+/g, ""));
}
function sortList(list) {
    var items = Array.from(list.children);
    items.sort(function(a, b) {
        return parseSalary(b) - parseSalary(a);
    });
    items.forEach(function(item) {
        return list.appendChild(item);
    });
}
function getEmployees(list) {
    return Array.from(list.children).map(function(employee) {
        var nameEmp = employee.textContent.trim();
        var position = employee.dataset.position;
        var salary = Number(employee.dataset.salary.replace(/[^0-9.-]+/g, ""));
        return {
            name: nameEmp,
            position: position,
            salary: salary,
            age: Number(employee.dataset.age)
        };
    });
}
sortList(employeesList);
getEmployees(employeesList);

//# sourceMappingURL=index.16900ee3.js.map
